import { CatalogDataType } from './MainView.container.props';
export var CMSFeedMap = new Map([
    [CatalogDataType.DTVNOW, '/idpcms/sales/buy/dtvnow'],
    [CatalogDataType.DTV, '/idpcms/sales/buy/directv'],
    [CatalogDataType.Wireless, '/idpcms/sales/buy/wireless'],
    [CatalogDataType.Bundle, '/idpcms/sales/buy/bundles'],
    [CatalogDataType.Offers, '/idpcms/sales/buy/offers'],
    [CatalogDataType.Broadband, '/idpcms/sales/buy/broadband'],
    [CatalogDataType.IPTV, '/idpcms/sales/buy/iptv'],
    [CatalogDataType.CARTCHECKOUT, '/idpcms/sales/buy/cartcheckout'],
]);
export var nameMap = new Map([
    [CatalogDataType.DTVNOW, 'dtvnow'],
    [CatalogDataType.DTV, 'dtv'],
    [CatalogDataType.Wireless, 'wireless'],
    [CatalogDataType.Bundle, 'bundles'],
    [CatalogDataType.Offers, 'offers'],
    [CatalogDataType.Broadband, 'broadband'],
    [CatalogDataType.IPTV, 'iptv'],
    [CatalogDataType.CARTCHECKOUT, 'cartcheckout'],
]);
export var titleMap = new Map([
    [CatalogDataType.DTV, 'Shop DIRECTV Packages'],
    [CatalogDataType.DTVNOW, 'Shop DIRECTV NOW Packages'],
    [CatalogDataType.Offers, 'Shop DIRECTV NOW'],
    [CatalogDataType.Bundle, 'Shop AT&T Bundles'],
    [CatalogDataType.Wireless, 'Shop WIRELESS'],
    [CatalogDataType.CrpPlanExisting, 'Shop WIRELESS'],
    [CatalogDataType.Wireless, 'Shop WIRELESS'],
    [CatalogDataType.SNG, 'Shop AND GO'],
    [CatalogDataType.Broadband, 'Shop AT&T Internet Service'],
    [CatalogDataType.IPTV, 'Shop IPTV'],
]);
// Added loadedPanelURL maps for porting the Page load events
export var loadedPanelURL = new Map([
    [CatalogDataType.DTVNOW, '/buy/dtvnow/learn'],
    [CatalogDataType.DTV, '/buy/directv/learn'],
    // [CatalogDataType.Wireless, '/buy/wireless/learn'],
    // Removed bundles learn page load as now it will be triggered by lobs
    // [CatalogDataType.Bundle, '/buy/bundles/learn'],
    [CatalogDataType.Offers, '/buy/offers/learn'],
    [CatalogDataType.Broadband, '/buy/broadband/learn'],
    [CatalogDataType.IPTV, '/buy/iptv/learn'],
]);
export var altTextForeGroundImage = new Map([
    [CatalogDataType.DTVNOW, 'Compatible device required'],
    [CatalogDataType.DTV, 'Foreground Image'],
    [CatalogDataType.Wireless, 'Foreground Image'],
    [CatalogDataType.Bundle, 'Foreground Image'],
    [CatalogDataType.Offers, 'Foreground Image'],
    [CatalogDataType.Broadband, 'Foreground Image'],
]);
//# sourceMappingURL=MainViewMaps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/MainView/MainViewMaps.js
// module id = 240
// module chunks = 8